import React from 'react';
import { MediaElement, MediaElementModel, ModuleSection, Stack } from '@/components';
import { ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import { animControllerInView } from '@/animations';

type MultimediaItemModel = ModuleBaseModel<
  {
    media: MediaElementModel;
  } & ModuleSectionPropsModel
>;

const MultimediaItem = (data: MultimediaItemModel) => {
  const {
    props: { media },
  } = data;

  if (!media) return null;

  return (
    <ModuleSection
      data={data}
      sectionHeadingProps={{
        className:
          'mx-auto flex w-full flex-col justify-center lg:w-3/4 print:w-full print:pb-0 lg:px-6 pb-8 md:pb-16 [&_.summary]:pt-5',
      }}
    >
      <Stack className="container" animation={animControllerInView({ amount: 'some', margin: '-20%' })}>
        <MediaElement
          className="MediaElement mx-auto flex w-full flex-col justify-center p-1.5 lg:w-3/4 print:w-full"
          {...media}
          imageElementProps={{
            widths: { xs: 600, sm: 960, md: 1246, lg: 1904, xl: 1904 },
            heights: { xs: 337, sm: 540, md: 700, lg: 1071, xl: 1071 },
            className: 'aspect-video',
          }}
        />
      </Stack>
    </ModuleSection>
  );
};

export default MultimediaItem;
